export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 3600;
export const SECONDS_PER_DAY = 86400;

export const DURATION_UNIT_KEYS = {
  days: 'app.reports.monitoring.duration.days',
  hours: 'app.reports.monitoring.duration.hours',
  minutes: 'app.reports.monitoring.duration.minutes',
  seconds: 'app.reports.monitoring.duration.seconds',
} as const;
